import request from "@/utils/request";

export interface BalanceInfo {
  amount?: number;
  totalConsume?: number;
  totalRecharge?: number;
  consumeCount?: number;
  rechargeCount?: number;
  creditLimit?: number;
  [key: string]: any;
}

export interface BalanceLog {
  id?: number | string;
  orderNo?: string;
  type?: number;
  amount?: number;
  amountAfter?: number;
  createdAt?: string;
  description?: string;
  createdByName?: string;
  [key: string]: any;
}

export interface BalanceLogParams {
  page?: number;
  size?: number;
  type?: number | string | null;
  startDate?: string | null;
  endDate?: string | null;
}

export const fetchBalanceInfo = () =>
  request.get<{
    code: number;
    data?: BalanceInfo;
    message?: string;
  }>("/asset/balance/info");

export const fetchBalanceLogs = (params: BalanceLogParams) =>
  request.get<{
    code: number;
    data?:
      | {
          records?: BalanceLog[];
          list?: BalanceLog[];
          rows?: BalanceLog[];
          total?: number;
          count?: number;
          totalCount?: number;
        }
      | BalanceLog[];
    message?: string;
  }>("/asset/log/list", { params });

export const rechargeBalance = (payload: {
  amount: number;
  type: number;
  description?: string;
}) => request.post("/asset/recharge", payload);

export const transferBalance = (payload: {
  username: string;
  amount: number;
  description?: string;
}) => request.post("/asset/balance/transfer", payload);

export const consumeBalance = (payload: Record<string, any>) =>
  request.post("/user/balance/consume", payload);

export const searchProducts = (params: { keyword: string }) =>
  request.get<{
    code: number;
    data?: Array<{ id: string | number; name: string }>;
    message?: string;
  }>("/asset/products/search", { params });

export const updateAdminPassword = (payload: {
  username: string;
  oldPassword: string;
  newPassword: string;
}) => request.post("/admin/updatePassword", payload);

export const updateProfileInfo = (payload: {
  id: number | string;
  username?: string;
  nickname?: string;
  telegram?: string;
  email?: string;
}) => request.post("/admin/update", payload);
